<template>
  <div>
    <div v-if="!areYouSure">
      <v-card-text class="pb-2">
        <v-form
          ref="personForm"
          v-model="personFormValid"
        >
          <v-text-field
            v-model="newPerson.name"
            autocomplete="off"
            class="mb-1"
            outlined
            label="Nimi"
            :rules="[rules.required]"
            required
          />
          <v-text-field
            v-model="newPerson.email"
            autocomplete="off"
            class="mb-1"
            outlined
            label="Sähköposti"
            :rules="[rules.required, rules.email]"
            required
          />
          <v-text-field
            v-model="newPerson.ssn"
            class="mb-1"
            autocomplete="off"
            outlined
            label="Hetu / Y-tunnus (valinnainen)"
          />
          <v-text-field
            v-model="newPerson.address"
            class="mb-1"
            autocomplete="off"
            outlined
            label="Osoite (valinnainen)"
          />
          <v-row>
            <v-col
              cols="12"
              md="6"
              class="py-0"
            >
              <v-text-field
                v-model="newPerson.zip"
                class="mb-1"
                autocomplete="off"
                outlined
                label="Postinumero (valinnainen)"
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="py-0"
            >
              <v-text-field
                v-model="newPerson.city"
                class="mb-1"
                autocomplete="off"
                outlined
                label="Kaupunki (valinnainen)"
              />
            </v-col>
          </v-row>
          <v-text-field
            v-model="newPerson.phone"
            class="mb-1"
            autocomplete="off"
            outlined
            label="Puhelin (valinnainen)"
          />
        </v-form>
      </v-card-text>
      <v-card-actions class="pb-4 pr-4 pt-0">
        <v-spacer/>
        <v-btn
          text
          @click="closePersonDialog()"
        >
          Peruuta
        </v-btn>
        <v-btn
          color="primary"
          text
          :disabled="!personFormValid"
          @click="addPerson()"
        >
          Ok
        </v-btn>
      </v-card-actions>
    </div>
    <div v-else>
      <v-card-text class="px-6 pt-0">
        Asiakasrekisterissä on jo henkilö jolla on sama nimi, henkilötunnus tai sähköposti.
        Oletko varma että haluta lisätä uuden henkilötiedon?
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          text
          @click="closePersonDialog()"
        >
          Peruuta
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="addPerson(true)"
        >
          Ok
        </v-btn>
      </v-card-actions>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import { apiPost } from '../api';

export default {
  name: 'BuyOrderPersonForm',
  props: {
    newPerson: {
      type: Object,
      default: () => {},
    },
    duplicates: {
      type: Object,
      default: () => ({
        offerers: false,
      }),
    },
    people: {
      type: Array,
      default: () => [],
    },
    editing: {
      type: Object,
      default: () => ({}),
    },
    indexes: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    areYouSure: false,
    personFormValid: false,
    rules: {
      required: value => !!value || 'Pakollinen kenttä.',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Virheellinen sähköpostiosoite.';
      },
    },
  }),
  methods: {
    closePersonDialog() {
      this.$bus.$emit('closePersonDialog');
    },
    resetForm() {
      this.newPerson.name = '';
      this.newPerson.phone = '';
      this.newPerson.address = '';
      this.newPerson.zip = '';
      this.newPerson.city = '';
      this.newPerson.email = '';
      this.newPerson.ssn = '';
      this.newPerson.id = null;
    },
    async addPerson(sure = false) {
      if (sure === false) this.$refs.personForm.validate();
      console.warn(this.newPerson.id);
      if (this.newPerson.id) {
        // update person
        await apiPost('customer/updateperson', this.newPerson);
        const person = this.people.find(p => p.id === this.newPerson.id);
        person.name = this.newPerson.name;
        person.phone = this.newPerson.phone;
        person.address = this.newPerson.address;
        person.zip = this.newPerson.zip;
        person.city = this.newPerson.city;
        person.email = this.newPerson.email;
        person.ssn = this.newPerson.ssn;
        this.$bus.$emit('showSnackbar', { color: 'green', message: 'Henkilötiedot päivitetty' });
        this.$bus.$emit('closePersonDialog');
      } else {
        // create new person
        if (sure) this.newPerson.sure = true;
        const response = await apiPost('customer/createperson', this.newPerson);
        if (response.personId) {
          this.people.push({ ..._.cloneDeep(this.newPerson), id: response.personId });
          this.$bus.$emit('showSnackbar', { color: 'green', message: 'Lisätty asiakasrekisteriin' });
          this.$bus.$emit('closePersonDialog');
          if (sure) delete this.newPerson.sure;
        } else if (response.message === 'Already exists') {
          // show modal to confirm!!
          // this.$bus.$emit('showSnackbar', { color: 'red', message: 'on jo samane' });
          console.warn('should ask if still want to add');
          this.areYouSure = true;
        }
        console.warn(response);
      }

    //   if (this.personFormValid && !this.editing.offerer) {
    //     this.buyOrder.persons.push(_.cloneDeep(this.newPerson));
    //     this.resetForm();
    //     this.$refs.personForm.resetValidation();
    //     this.$bus.$emit('closePersonDialog');
    //   } else if (this.personFormValid) {
    //     this.buyOrder.persons[this.indexes.offerer] = _.cloneDeep(this.newPerson);
    //     this.resetForm();
    //     this.$refs.personForm.resetValidation();
    //     this.$bus.$emit('closePersonDialog');
    //     this.editing.offerer = false;
    //     this.indexes.offerer = null;
    //   }
    //   const seen = new Set();
    //   this.duplicates.offerers = this.form.offerers
    //     .some(currentObject => seen.size === seen.add(currentObject.email).size);
    },
  },
};
</script>
